<div class="overflow-a">
  <ul class="breadcrumbs__list" [hidden]="!(chain && chain.length)">
    @for (el of chain; track el; let i = $index) {
      <li class="breadcrumbs__element">
        @if (el['url']) {
          <a [routerLink]="el['url']">
            @if (i) {
              <i class="fa fa-chevron-right"></i>
            }
            <span [ngClass]="el['opts']['class']">{{el['caption']}}</span>
          </a>
        }
        @if (!el['url']) {
          @if (i) {
            <i class="fa fa-chevron-right"></i>
          }
          <span [ngClass]="el['opts']['class']">{{el['caption']}}</span>
        }
      </li>
    }
  </ul>
</div>
